import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

const defaultFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'link',
];

const RichTextEditor = ({
  value,
  onChange,
  placeholder = '',
  className = '',
  minHeight = 112,
  readOnly = false,
}) => {
  return (
    <div
      className={`rounded-2xl border border-gray-200 bg-white ${className} ${
        readOnly ? 'opacity-95' : ''
      }`}
    >
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        modules={readOnly ? { toolbar: false } : defaultModules}
        formats={defaultFormats}
        readOnly={readOnly}
      />
      <style>{`
        .ql-toolbar.ql-snow {
          border: none;
          border-bottom: 1px solid rgb(229 231 235);
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
        }
        .ql-container.ql-snow {
          border: none;
          border-bottom-left-radius: 1rem;
          border-bottom-right-radius: 1rem;
        }
        .ql-editor {
          padding: 0.75rem 1rem;
          font-size: 0.875rem;
          line-height: 1.25rem;
        }
        .ql-editor.ql-blank::before {
          font-style: normal;
          color: rgb(156 163 175);
        }
        .ql-editor {
          min-height: ${typeof minHeight === 'number' ? `${minHeight}px` : minHeight};
        }
      `}</style>
    </div>
  );
};

export default RichTextEditor;

